import DashboardResult from "./DashboardResult";

export default DashboardResult;
